const fromdata = [{
		inputdata: "",
		title: "产品线",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		pt: true,
		width: "300px",
		lablewith: "110px",
		btx: false,
		options: [],
		event: "invClass"
	}, {
		inputdata: "",
		title: "LEVEL3",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		pt: true,
		width: "300px",
		lablewith: "110px",
		btx: false,
		options: []
	},
	{
		inputdata: "",
		title: "经销商",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "selectautocomplete",
		pt: true,
		width: "310px",
		btx: false,
		lablewith: "110px",
		options: [],
	},
	{
		inputdata: "",
		title: "返利点",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		pt: true,
		width: "300px",
		lablewith: "110px",
		btx: false,
	},
	{
		inputdata: "",
		title: "启效日期",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "dates",
		pt: true,
		width: "310px",
		btx: false,
		lablewith: "110px",
		options: [],
	},
	{
		inputdata: "",
		title: "有效期至",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "dates",
		pt: true,
		width: "310px",
		btx: false,
		lablewith: "110px",
		options: [],
	}
];
export default fromdata;